const header = document.getElementById('header');
const main = document.getElementById('main');

if (header && main) {
	const headerHeight = header.offsetHeight;
	let lastScrollY = 0;
	let isFixed = false;
	let ticking = false;

	const onScroll = () => {
		const currentScrollY = window.scrollY;

		if (currentScrollY === 0) {
			if (isFixed) {
				header.classList.remove('is-fixed', 'is-hidden', 'is-animated');
				main.style.paddingTop = '';
				isFixed = false;
			}
		} else if (currentScrollY > headerHeight) {
			if (!isFixed) {
				header.classList.add('is-fixed', 'is-hidden');
				main.style.paddingTop = headerHeight + 'px';
				isFixed = true;
				requestAnimationFrame(() => {
					header.classList.add('is-animated');
				});
			}

			if (currentScrollY < lastScrollY) {
				header.classList.remove('is-hidden');
			} else {
				header.classList.add('is-hidden');
			}
		}

		lastScrollY = currentScrollY;
		ticking = false;
	};

	window.addEventListener('scroll', () => {
		if (!ticking) {
			requestAnimationFrame(onScroll);
			ticking = true;
		}
	}, { passive: true });
}

// ── Mobile menu toggle ──
const mobileToggle = document.querySelector('.mobile-toggle');
const navMenu = document.getElementById('nav-menu');

if (mobileToggle && header) {
	const openMenu = () => {
		header.classList.add('menu-open');
		document.body.classList.add('no-scroll');
		mobileToggle.setAttribute('aria-expanded', 'true');

		// Move focus into the menu
		const firstLink = navMenu.querySelector('.nav-item');
		if (firstLink) firstLink.focus();
	};

	const closeMenu = () => {
		header.classList.remove('menu-open');
		document.body.classList.remove('no-scroll');
		mobileToggle.setAttribute('aria-expanded', 'false');

		// Close any open subnavs
		document.querySelectorAll('.nav-parent.subnav-open').forEach(el => {
			el.classList.remove('subnav-open');
		});

		mobileToggle.focus();
	};

	mobileToggle.addEventListener('click', () => {
		if (header.classList.contains('menu-open')) {
			closeMenu();
		} else {
			openMenu();
		}
	});

	// Escape key closes mobile menu or subnav
	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;
		if (!header.classList.contains('menu-open')) return;

		// If a subnav is open, close it first
		const openSubnav = document.querySelector('.nav-parent.subnav-open');
		if (openSubnav) {
			openSubnav.classList.remove('subnav-open');
			openSubnav.querySelector('.nav-item').focus();
			return;
		}

		closeMenu();
	});

	// Focus trap within mobile menu
	if (navMenu) {
		navMenu.addEventListener('keydown', (e) => {
			if (e.key !== 'Tab') return;
			if (window.innerWidth >= 1200) return;

			const focusable = navMenu.querySelectorAll(
				'a[href], button, [tabindex]:not([tabindex="-1"])'
			);
			if (!focusable.length) return;

			const first = focusable[0];
			const last = focusable[focusable.length - 1];

			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault();
				mobileToggle.focus();
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault();
				mobileToggle.focus();
			}
		});

		// Wrap from toggle back into menu
		mobileToggle.addEventListener('keydown', (e) => {
			if (e.key !== 'Tab') return;
			if (!header.classList.contains('menu-open')) return;

			const focusable = navMenu.querySelectorAll(
				'a[href], button, [tabindex]:not([tabindex="-1"])'
			);
			if (!focusable.length) return;

			if (e.shiftKey) {
				e.preventDefault();
				focusable[focusable.length - 1].focus();
			} else {
				e.preventDefault();
				focusable[0].focus();
			}
		});
	}

	// Subnav slide logic
	document.querySelectorAll('.nav-parent.has-children > .nav-item').forEach(link => {
		link.addEventListener('click', (e) => {
			if (window.innerWidth < 1200) {
				e.preventDefault();
				const parent = link.closest('.nav-parent');
				parent.classList.add('subnav-open');
				link.setAttribute('aria-expanded', 'true');

				// Focus the first item in the subnav
				const firstChild = parent.querySelector('.nav-dropdown-item');
				if (firstChild) firstChild.focus();
			}
		});
	});

	document.querySelectorAll('.mobile-subnav .back').forEach(back => {
		back.addEventListener('click', () => {
			const parent = back.closest('.nav-parent');
			parent.classList.remove('subnav-open');

			const navItem = parent.querySelector('.nav-item');
			if (navItem) {
				navItem.setAttribute('aria-expanded', 'false');
				navItem.focus();
			}
		});
	});

	// Close menu on resize to desktop
	window.addEventListener('resize', () => {
		if (window.innerWidth >= 1200) {
			header.classList.remove('menu-open');
			document.body.classList.remove('no-scroll');
			mobileToggle.setAttribute('aria-expanded', 'false');
			document.querySelectorAll('.nav-parent.subnav-open').forEach(el => {
				el.classList.remove('subnav-open');
			});
		}
	});
}
